export default "__VITE_ASSET__f1139f10__"